export default __webpack_public_path__ + "static/media/RobotoMono-ExtraLight.2ccde177.ttf";